import { getAmplitudeInstance } from '../amplitudeHelpers';
import DismissAction from '../enums/DismissAction';
import PoiLocation from '../enums/PoiLocation';
import PointOfInterestType from '../enums/PointOfInterestType';
import POISource from '../enums/POISource';

type logPOIDrawerDismissedParams = {
  dismiss_action?: DismissAction;
  osm_category?: string;
  poi_id?: number;
  poi_location?: PoiLocation;
  poi_source?: POISource;
  poi_type?: PointOfInterestType;
};

/**
 * A user dismisses a POI preview (drawer or popover) without converting on its primary CTA. Fires for all POI sources — AllTrails-curated POIs, OSM-sourced points, and community waypoints — distinguished by poi_source.
 * @param params - Attributes to log with the amplitude event
 * @param params.dismiss_action - Describes the specific type of action taken to exit out of the POI preview.
 * @param params.osm_category - OSM tag category of the dismissed POI. OSM tag category of the clicked POI. Examples include mountain, campsite, waterfall, &tc. Null when poi_source is not 'osm'.
 * @param params.poi_id - Unique identifier of poi tapped.
 * @param params.poi_location - The map surface on which the POI preview was dismissed (e.g. explore map, custom route builder, navigator map, trail page).
 * @param params.poi_source - Data source of the dismissed POI (osm, poi, or community waypoint).
 * @param params.poi_type - Describes the specific type of POI.
 */
const logPOIDrawerDismissed = (
  { dismiss_action, osm_category, poi_id, poi_location, poi_source, poi_type }: logPOIDrawerDismissedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'poi drawer dismissed',
    {
      'dismiss action': dismiss_action,
      'osm category': osm_category,
      'poi id': poi_id,
      'poi location': poi_location,
      'poi source': poi_source,
      'poi type': poi_type
    },
    callback
  );
};

export default logPOIDrawerDismissed;
